import React from 'react'
import Helmet from 'react-helmet';

import Base from './base';
import { Parent } from '../layouts/parent';

import { ContentHead } from '../components/content-head';
import { EventInfo } from '../components/event-info';
import { RichText } from '../components/rich-text';
import { Director } from '../components/director';

export default class ContentPage extends Base {
  get backgroundColor () {
    return this.content.page?.festival?.color || '#5F58FA';
  }

  get breadcrumb () {
    return this.content.page.festival.title;
  }

  get injected () {
    return this.content.injected || {};
  }

  render () {
    return (
      <Parent { ...this.content }>
        <Helmet>
          <title>{ `${this.content.page.longTitle} - Europalia Arts Festival` }</title>
          <meta name="description" content={this.content.page.excerpt} />
          { this.image && <meta property="og:image" content={'https:' + this.image } /> }
        </Helmet>

        <ContentHead
          title={this.content.page.longTitle}
          images={this.content.page.headerImages}
          backgroundColor={this.backgroundColor}
        />

        <Director modules={ this.content.page.modulesAboveContent || [] } />

        <section className="content-columns">
          <div className="content-columns__container container">
            <div className="content-columns__left typo-body">
              <RichText document={this.content.page.contentLeft} language={this.content.page.language} />
            </div>
            <div className="content-columns__spacer" />
            <div className="content-columns__right typo-body">
              <EventInfo {...this.content.page} />
            </div>
          </div>
        </section>

        <Director modules={ this.content.page.modulesBelowContent || [] } />
      </Parent>
    );
  }
}